import {
  initialState,
  Actions,
  State,
  GET_ALL_JUDICIALES,
  GET_ALL_JUDICIALES_SUCCESS,
  GET_ALL_JUDICIALES_ERROR,
  RESET_GET_ALL_JUDICIALES,
} from "../../types/judicial/getAll";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_JUDICIALES:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_JUDICIALES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_JUDICIALES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ALL_JUDICIALES:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
